import creatureLogo from '@/assets/studios/creature.png';
import kylotonnLogo from '@/assets/studios/kylotonn.png';
import naconLogo from '@/assets/studios/nacon.png';

/** `mono` logos are single-colour and get recoloured to follow the theme. */
interface StudioLogo {
  src: string;
  mono?: boolean;
}

const defaultLogo: StudioLogo = { src: naconLogo, mono: true };

const studioLogoMap: Record<string, StudioLogo> = {
  crea_ture: { src: creatureLogo, mono: true },
  kylotonn: { src: kylotonnLogo },
};

export const getStudioLogo = (studioCode: string): StudioLogo => {
  return studioLogoMap[studioCode.toLowerCase()] ?? defaultLogo;
};
